export const transactionTitles = {
  "transfer-sent": "Transfer Sent",
  "transfer-received": "Transfer Received",
  withdrawal: "Withdrawal",
  deposit: "Deposit",
  "parley-rebate": "Parley 10% Cashback",
  "morning-promotion-award": "Morning Deposit Promotion",
  "betby-bet": "Betby - Bet Lost",
  "betby-win": "Betby - Bet Won",
  "betby-refund": "Betby - Bet Refund",
  "pixmove-bet": "Pixmove - Bet Lost",
  "pixmove-win": "Pixmove - Bet Won",
  "pixmove-rollback": "Pixmove - Bet Refund",
  "pragmatic-bet": "Pragmatic - Bet Lost",
  "pragmatic-win": "Pragmatic - Bet Won",
  "pragmatic-refund": "Pragmatic - Bet Refund",
  "hacksaw-rollback": "Hacksaw - Bet Refund",
  "hacksaw-win": "Hacksaw - Bet Won",
  "hacksaw-bet": "Hacksaw - Bet Lost",
  "kaga-win": "Kaga - Bet Won",
  "kaga-bet": "Kaga - Bet Lost",
  "gamingcorps-bet": "Gamingcorps - Bet Lost",
  "gamingcorps-win": "Gamingcorps - Bet Won",
  "gamingcorps-refund": "Gamingcorps - Bet Refund",
  "bgaming-lost": "BGaming - Bet Lost",
  "bgaming-win": "BGaming - Bet Won",
  "bgaming-bet": "BGaming - Bet Lost",
  "bgaming-refund": "BGaming - Bet Refund",
  "upgaming-bet": "Upgaming - Bet Lost",
  "upgaming-win": "Upgaming - Bet Won",
  "upgaming-lost": "Upgaming - Bet Lost",
  "upgaming-refund": "Upgaming - Bet Refund",
  "pragmatic-adjustment": "Pragmatic - Adjustment",
  "lottery-ticket-purchase": "Lottery Ticket Purchased",
  "lottery-winnings": "Lottery Winnings",
};
